module.exports = __webpack_public_path__ + "img/fire.8bf46fd9.svg";